module.exports = __webpack_public_path__ + "static/img/process.ea79f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gene_second/large_fragments_page/process.png
// module id = vdVu
// module chunks = 16